// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-2fYdO","lds-ring":"index-lds-ring-2dlZ_"};